import * as Sentry from "@sentry/react";

if (process.env["REACT_APP_ENV"] === "production") {
  Sentry.init({
    dsn: process.env["REACT_APP_SENTRY_DSN"],
    environment: process.env["REACT_APP_DASH_ENV"],
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.1,
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Relative to tracesSampleRate (final rate = traces * profiles)
    profilesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  });
}
